import { apiFetch } from './api-client'
import { useAuthStore } from './auth-store'

/**
 * Wraps apiFetch with the current user's organisationId, scoping calls to
 * /organisations/:orgId/...  Throws if there's no org on the JWT.
 */
export function orgFetch<T>(
  path: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<T> {
  const orgId = useAuthStore.getState().user?.organisationId
  if (!orgId) {
    throw new Error('orgFetch called without an organisation in the session')
  }
  const p = path.startsWith('/') ? path : `/${path}`
  return apiFetch<T>(`/organisations/${orgId}${p}`, options)
}
